import { cn } from "@theprelude/core";

export const Rapid7Icon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.7738 3H1.58395C1.79989 3.22009 2.01376 3.44642 2.21101 3.6852C3.79943 5.60999 4.6362 8.02895 4.6362 10.6888C4.6362 14.7979 2.90659 18.5042 0.128418 21H8.81593L12.9437 10.7386H7.77774L8.63943 6.75822H18.9008L13.5127 20.9979H15.6264C20.5453 21.0291 23.8716 16.9449 23.8716 11.9824C23.8716 7.01984 20.701 3 15.7697 3" />
  </svg>
);
